/**
 * Spinner — CSS-animated busy indicator.
 *
 * Replaces the legacy BusyIndicator (previously `webcomponents-react` `BusyIndicator`) for the prince-ui
 * migration (prince-ui has no Spinner equivalent).
 *
 * Props:
 *   active  show the spinner (default true); when false the element is hidden
 *   size    "s" | "m" | "l" (default "m")
 *
 * Styles live in kit.css (.prn-spinner, .prn-spinner--{s|m|l}).
 */

import "./kit.css";

export type SpinnerSize = "s" | "m" | "l";

export interface SpinnerProps {
  /** Whether the spinner is visible. Default: true. */
  active?: boolean;
  /** Visual size: "s" (16 px) | "m" (24 px) | "l" (40 px). Default: "m". */
  size?: SpinnerSize;
  /** Additional CSS class names. */
  className?: string;
}

export function Spinner({ active = true, size = "m", className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-busy={active}
      aria-label="Laden…"
      hidden={!active || undefined}
      className={["prn-spinner", `prn-spinner--${size}`, className]
        .filter(Boolean)
        .join(" ")}
    />
  );
}
